import { Features } from '../util/constants';
import useBeAbleToStartChase from './useBeAbleToStartChase';
import useOrganisation from './useOrganisation';

const featureKeys = Object.values(Features);

export default function usePlanLimits(addonLimitsName) {
  const { plan } = useBeAbleToStartChase();
  const org = useOrganisation();
  const features = (plan?.features || org.subscription?.plan?.features) ?? {};

  return featureKeys.reduce((acc, k) => {
    const v = features[k];
    const overage = plan?.addons?.[addonLimitsName ?? k]?.overages ?? 0;

    if (typeof v === 'boolean') {
      acc[k] = !!v;
      return acc;
    }

    acc[k] = v ? v + overage : 9999;

    return acc;
  }, {});
}
